// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 980
// module chunks = 0